export default function Services() {
  const services = [
    {
      id: 1,
      label: 'Application Support',
      title: 'University & Course Selection',
      description: 'Expert guidance in choosing the right university and program that aligns with your career goals, budget, and qualifications.',
      image: 'https://public.readdy.ai/ai/img_res/caa52dfbfc973b0f2e1b5cf2ac434f17.jpg',
      icon: 'ri-book-open-line'
    },
    {
      id: 2,
      label: 'Visa Guidance',
      title: 'Complete Documentation Assistance',
      description: 'Comprehensive support with visa applications, document preparation, and interview coaching to ensure a smooth approval process.',
      image: null,
      icon: 'ri-passport-line',
      darkBg: true
    },
    {
      id: 3,
      label: 'Pre-Departure',
      title: 'Orientation & Travel Support',
      description: 'Detailed pre-departure briefings covering accommodation, travel arrangements, cultural adaptation, and what to expect in your new country.',
      image: 'https://readdy.ai/api/search-image?query=happy%20international%20students%20at%20airport%20departure%20terminal%20with%20luggage%20and%20backpacks%2C%20excited%20expressions%2C%20modern%20airport%20interior%2C%20bright%20natural%20lighting%2C%20beginning%20of%20study%20abroad%20journey%2C%20diverse%20group%20of%20young%20adults&width=600&height=400&seq=service-003&orientation=landscape',
      icon: 'ri-plane-line'
    }
  ];

  return (
    <section id="services" className="py-16 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 mb-12 sm:mb-16">
          <div>
            <p className="text-gray-500 text-sm uppercase tracking-wider mb-2">Our Services</p>
            <h3 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 italic">
              Everything You Need for Success Abroad
            </h3>
          </div>
          <div className="flex items-center">
            <p className="text-gray-600 leading-relaxed text-sm sm:text-base">
              From selecting the perfect university to settling into your new home abroad, we provide comprehensive support at every step. Our experienced team ensures your study abroad journey is smooth, stress-free, and successful.
            </p>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8">
          {services.map((service) => (
            <div
              key={service.id}
              className={`rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 ${
                service.darkBg ? 'bg-slate-900' : 'bg-white'
              }`}
            >
              {service.image ? (
                <div className="h-64 w-full overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover object-center"
                  />
                </div>
              ) : (
                <div className="h-64 flex items-center justify-center">
                  <div className="w-32 h-32 flex items-center justify-center">
                    <i className={`${service.icon} text-8xl text-emerald-400`}></i>
                  </div>
                </div>
              )}
              <div className="p-6 space-y-3">
                <p
                  className={`text-sm font-medium ${
                    service.darkBg ? 'text-emerald-400' : 'text-emerald-600'
                  }`}
                >
                  {service.label}
                </p>
                <h4
                  className={`text-2xl font-bold ${
                    service.darkBg ? 'text-white' : 'text-slate-900'
                  }`}
                >
                  {service.title}
                </h4>
                <p
                  className={`text-sm leading-relaxed ${
                    service.darkBg ? 'text-gray-300' : 'text-gray-600'
                  }`}
                >
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
